import { Component, OnDestroy, OnInit } from '@angular/core';

import { LoginService } from '../../../services/login.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {

  isLoggedIn: boolean;
  isLoginClient = false;

  private destroy$ = new Subject<void>();

  private isLoggedInService = false;
  private isLoginRoute = false;

  constructor(
    private loginService: LoginService,
    private router: Router) { }

  ngOnInit(): void {
    this.loginService.isLoggedIn$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.isLoggedInService = data;
      this.recalculateIsLoggedIn();
    });

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data.url) {
        this.isLoginRoute = data.url !== '/login';
        this.recalculateIsLoggedIn();

        if (data.url === '/login-client') {
          this.isLoginClient = true;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showDivFixed(): boolean {
    if (this.router.url === '/air' || this.router.url === '/thermal' || this.router.url === '/calibrates') {
      return true;
    } else {
      return false;
    }
  }

  public mailTo(type: string): void {
    const url = `mailto:feedback@qloudapp.com?subject=${type}`;
    window.open(url, '_blank');
  }

  private recalculateIsLoggedIn() {
    this.isLoggedIn = this.isLoggedInService && this.isLoginRoute;
  }
}
